import React from "react"
import authorImg from "../../images/author1.jpg"
import blogPhoto from "../../images/item1.jpg"
import { useStaticQuery, graphql } from "gatsby"

const StoriesList = ({ test, filterList }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            stories {
              item {
                name
                date
                mainPhoto
                title
                smallDescription
                stories
                link
                tags
                id
                place
                videoLink
                audioLink
              }
            }
          }
        }
      }
    `
  )
  // let filterArray =
  //   site.siteMetadata &&
  //   site.siteMetadata.norwayItems.map(items => items.item.status.season)
  // let uniqueArray = filterArray.filter(function(item, pos) {
  //   return filterArray.indexOf(item) == pos
  // })
  console.log("SITE META", filterList)

  return (
    <>
      {filterList && filterList.length > 0 ? (
        filterList.map((item, index) => (
          <div className="box" key={index}>
            <div className="user-info">
              <img src={authorImg} alt="user" />
              <div className="name">
                {item.item.name}
                <span>{item.item.date}</span>
              </div>
            </div>
            <div className="photo">
              <img src={item.item.mainPhoto} alt="Blog cover" />
            </div>
            <div className="content">
              <h2>{item.item.title}</h2>
              <p>{item.item.smallDescription}</p>
              {item.item.link === "written" ? (
                <a href={`/destinations/stories/${item.item.id}`}>Read More</a>
              ) : null}
              {item.item.link === "audio" ? (
                <a href={`/destinations/audioStory/${item.item.id}`}>
                  Read More
                </a>
              ) : null}
              {item.item.link === "video" ? (
                <a href={`/destinations/videoStory/${item.item.id}`}>
                  Read More
                </a>
              ) : null}
            </div>
          </div>
        ))
      ) : (
        <>
          {site.siteMetadata && site.siteMetadata.stories
            ? site.siteMetadata.stories.map((item, index) => (
                <div className="box" key={index}>
                  <div className="user-info">
                    <div className="name">
                      {item.item.name}
                      <span>{item.item.date}</span>
                    </div>
                  </div>
                  <div className="photo">
                    <img src={item.item.mainPhoto} alt="Blog cover" />
                  </div>
                  <div className="content">
                    <h2>{item.item.title}</h2>
                    <p>{item.item.smallDescription}</p>
                    {item.item.link === "written" ? (
                      <a href={`/destinations/stories/${item.item.id}`}>
                        Read More
                      </a>
                    ) : null}
                    {item.item.link === "audio" ? (
                      <a href={`/destinations/audioStory/${item.item.id}`}>
                        Read More
                      </a>
                    ) : null}
                    {item.item.link === "video" ? (
                      <a href={`/destinations/videoStory/${item.item.id}`}>
                        Read More
                      </a>
                    ) : null}
                  </div>
                </div>
              ))
            : null}
        </>
      )}
    </>
  )
}
export default StoriesList
